import ImageWithFallback from "@/Components/ImageWithFallback";
import Modal from "@/Components/Modal/Modal";
import { getOriginalUrl } from "@/shared/imageLibrary/originalUrl";

interface ImagePreviewModalProps {
  src: string;
  alt?: string;
  onExit: () => void;
}

/** Shows an image big, in its original size and crop. */
const ImagePreviewModal = ({ src, alt, onExit }: ImagePreviewModalProps) => (
  <Modal
    show
    onExit={onExit}
    className="md:w-[90vw]"
    contentClassName="p-4 pt-16 md:pt-16 lg:pt-16"
  >
    <ImageWithFallback src={getOriginalUrl(src)} alt={alt} />
  </Modal>
);

export default ImagePreviewModal;
